const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  menus: state => state.user.menus,
  isSuper: state => state.user.isSuper,
  infoLoaded: state => state.user.infoLoaded,
  permissionRoutes: state => state.permission.routes,
  addRoutes: state => state.permission.addRoutes,
  routesAdded: state => state.permission.routesAdded,
  sidebar: state => state.app.sidebar,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  appName: state => state.brand.appName,
  platformLogo: state => state.brand.logo
}

export default getters
